import React, { useMemo, useState, useEffect } from 'react';
import styles from '../styles/FloatingBackground.module.css';

const FloatingBackground = () => {
  // Mouse position for spotlight effect
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  // Configuration - adjust this to control density
  const SYMBOL_COUNT = 0;
  const symbols = useMemo(() => ['<>', '</>', '{ }', '( )', '[ ]', '=>', '//', '&&', '||', '===', '...', '?:', '!='], []);
  
  // Generate random symbols with varied positions (memoized)
  const floatingSymbols = useMemo(() => 
    Array.from({ length: SYMBOL_COUNT }, (_, i) => ({
      id: i,
      symbol: symbols[i % symbols.length],
      style: {
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 20}s`,
        animationDuration: `${20 + Math.random() * 15}s`,
      }
    })), [symbols]
  );

  return (
    <div className={styles.floating_bg}>
      {/* Global Mouse Spotlight */}
      <div 
        className={styles.spotlight}
        style={{
          background: `radial-gradient(600px circle at ${mousePosition.x}px ${mousePosition.y}px, rgba(99, 102, 241, 0.12), transparent 40%)`,
        }}
      />
      
      {/* Floating Symbols */}
      {floatingSymbols.map(({ id, symbol, style }) => (
        <span key={id} className={styles.symbol} style={style}>
          {symbol}
        </span>
      ))}
    </div>
  );
};

export default FloatingBackground;
